import React, {Component} from 'react';
import {Button, FormGroup, Form, Label, Input, Modal, ModalBody, ModalFooter, ModalHeader, NavLink, Row} from "reactstrap";
import {FormattedMessage, injectIntl} from "react-intl";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/pro-light-svg-icons";
import * as toast from "react-toastify";
import { handleRequestError, Request } from '../../helpers/request'

class PasswordResetRequestModal extends Component {
    state = {
        email: '',
    };

    submitReset = (e) => {
        e.preventDefault();
        const { email } = this.state;
        const { intl } = this.props;

        Request.post('password/email', { email })
            .then(data => {
                toast.toast.success(
                    intl.formatMessage({
                        id: 'portfolio.reset_request.success',
                        defaultMessage: 'Vous allez recevoir un email contenant le lien pour choisir un nouveau mot de passe.'
                    })
                );
                this.props.close();
            })
            .catch(handleRequestError)
    };

    render()
    {
        const { intl } = this.props;
        const { email } = this.state;

        return (
            <Modal className="alert-wrapper active" size='lg' isOpen={this.props.isOpen} toggle={this.props.close}>
                <ModalHeader>
                    <span className="cross-icon" onClick={this.props.close}>
                        <FontAwesomeIcon icon={faTimes}/>&nbsp;
                    </span>

                </ModalHeader>
                <div className="popup-head">
                    <h2 className='text-uppercase mb-3'>
                        <FormattedMessage id="portfolio.reset_request.title"
                                          defaultMessage="Vous avez oublié votre mot de passe ?"/>
                    </h2>
                    <p>
                        <FormattedMessage id="portfolio.reset_request.subtitle"
                                          defaultMessage="Veuillez saisir l’email associé à votre compte. Vous recevrez un email contenant le lien pour choisir un nouveau mot de passe."/>
                    </p>
                </div>
                <Form onSubmit={(e) => this.submitReset(e)}>
                    <ModalBody className="popup-content p-0">
                        <FormGroup>
                            <Label className='text-uppercase'>
                                <FormattedMessage id="portfolio.reset_request.email.label"
                                                  defaultMessage="Votre email"/>
                            </Label>
                            <Input
                                type="email"
                                value={email}
                                onChange={(e) => this.setState({ email: e.target.value })}
                                placeholder={
                                    intl.formatMessage({
                                        id: 'portfolio.reset_request.email.placeholder',
                                        defaultMessage: "Entrez l’adresse email de votre compte"
                                    })
                                }
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter className='popup-btn d-md-flex justify-content-center text-center'>
                        <Button
                            xs="2"
                            className="btn blue-btn text-uppercase"
                            type='submit'>
                            <FormattedMessage id="portfolio.reset_request.button"
                                              defaultMessage="Recevoir le lien"/>
                        </Button>{' '}
                    </ModalFooter>
                </Form>
        </Modal>
        )
    }
}

PasswordResetRequestModal.defaultProps = {
    isOpen: false,
    close: null,
};

export default injectIntl(PasswordResetRequestModal);
